import React from "react";
import IncentiveSheet from "./NonItModule/IncentiveSheet";
import MasterSheet from "./NonItModule/MasterSheet";
import TableIncentive from "./TableIncentive";
import IncentiveModuleLayout from "./IncentiveModuleLayout";

const NonItModule = () => {
  const nonItModuleTabs = [
    {
      title: "Master Sheet",
      page: <MasterSheet />,
      type: "main",
    },
    {
      title: "Incentive Sheet",
      page: <IncentiveSheet />,
      type: "main",
    },
  ];

  /* 
    Original logic has "modalContent" with "type" and "module" props.
    onClick was: () => setSelectedModal("RA").
    Layout handles mapping: adds onClick based on title. 
    So we just need data objects.
  */

  return (
    <IncentiveModuleLayout
      moduleName="NonIT"
      initialCards={[]}
      tabs={nonItModuleTabs}
      tabId="non-it-module"
    />
  );
};

export default NonItModule;
